// extracted by mini-css-extract-plugin
export default {"headerToggle":"ViewToggle_headerToggle__h9pSk","toggleBtn":"ViewToggle_toggleBtn__BuGdi","active":"ViewToggle_active__p6Xa5","disabled":"ViewToggle_disabled__TwWxd"};